
import Urls from "./url"


export const fetchSingleNews = async (name: string) => {
    const url = Urls('singleNewsUrl', name);
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}
export const fetchAllNews = async (lan:string) => {
    const url = Urls('allNews',lan);
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}
export const fetchNewsByTaxonomy = async (id: string) => {
    const url = Urls('byTaxonomyNewsUrl', id);
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}

export const fetchNewsTaxonomy=async(id:string)=>{
    let Id="";
    if(id)Id=id;
    const url=Urls('NewsTaxonomyUrl',Id);
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}

